import { useHistory } from "react-router-dom";
import { Routes } from "../../../../AppRoutes";
import { openUrl } from "../../../../helper/util";
import { Box } from "../../../../components";
import DataGrid, { Column, ColumnFixing, FilterRow, HeaderFilter, Paging, Scrolling } from "devextreme-react/data-grid";
import { Spin } from "antd";
import { useDocumentLink } from "../../../statistics/hooks/use-document-link";

export const DocumentNeedProcessList = () => {
  const history = useHistory();
  const { mappedNeedProcessDocument, isLoading } = useDocumentLink();

  const openDocumentUrl = (item: any) => {
    if (!item?.url) {
      history.push(Routes.documentDetail.path.replace(":id", `${item.listItemId}?fileId=${item.id}&action=link`));
      return;
    }

    openUrl(item?.url);
  };

  if (isLoading) return <Spin />;

  return (
    <div className={"Content__grid-hide"}>
      <Box title={"Tài liệu cần xử lý"}>
        <div className="d-flex justify-content-end pb-2">
          <p className="font-weight-bold">
            Tổng cộng:{" "}
            <span className="text-primary" style={{ fontSize: "22px" }}>
              {mappedNeedProcessDocument?.length}
            </span>{" "}
            tài liệu
          </p>
        </div>
        <DataGrid
          id="grid__title-container"
          dataSource={mappedNeedProcessDocument}
          noDataText="Không tìm thấy tài liệu"
          showBorders={true}
          rowAlternationEnabled={true}
          wordWrapEnabled={true}
          showRowLines={false}
          // dataRowRender={(datRow) => (
          //   <DocumentDataGridItem
          //     document={datRow.data}
          //     isShowAction={false}
          //     isShowCheckColumn={false}
          //     openDocumentUrl={openDocumentUrl}
          //     goToDetail={goToDetail}
          //     wordWrapEnabled={true}
          //   />
          // )}
        >
          <Scrolling mode="standard" />
          <ColumnFixing enabled={true} />
          <FilterRow visible={true} applyFilter={true} />
          <HeaderFilter visible={true} />
          <Paging defaultPageSize={20} />

          <Column
            fixed={true}
            fixedPosition="left"
            dataField="Title"
            caption="Tên tài liệu"
            minWidth={250}
            cellRender={(props) => (
              <p
                role="link"
                onClick={() => openDocumentUrl(props.data)}
                style={{ textDecoration: "underline", cursor: "pointer" }}
              >
                {props.displayValue}
              </p>
            )}
          />
          <Column dataField="docType" caption="Loại tài liệu" />
          <Column dataField="docStatus" caption="Tình trạng" />
        </DataGrid>
      </Box>
    </div>
  );
};
